import { withStyles } from "@material-ui/core";
import React from "react";
import Details from "./Details";
import Dropdown from "../../../../../../common/Dropdown";
import { getEquipmentSuffix } from "../../../../utils/utils";

const styles = (theme) => ({
  container: {
    display: "flex",
    border: `1px solid ${theme.AppBGColor}`,
    flexDirection: "row",
    flexGrow: 1,
    marginRight: 12,
    padding: "10 12 10 12",
    justifyContent: "space-between"
  },
  innerContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column"
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "130px",
    },
  },
  selectRoot: {
    marginTop: 8,
    marginBottom: 4,
  },
  inputField: {
    padding: 0,
  },
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  label: {
    color: theme.iconColor,
    fontWeight: 400,
    lineHeight: "16px",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
});
const EquipmentContainer = ({
  classes,
  driverInfo,
  currentDriverManifests,
  changeRouteData,
  currentDriverRouteNames,
  currentDriverTrailers,
  showTrailerScac,
}) => {
  const trailerNumberWithScacCode = `${
    driverInfo.trailerNumber
  } ${getEquipmentSuffix({
    equipmentScac: driverInfo.trailerScac,
    showTrailerScac,
  })}`;

  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        {driverInfo.tractorNumber ? (
          <Details label="Tractor" value={driverInfo.tractorNumber} minWidth/>
        ) : (
          ""
        )}
        {currentDriverRouteNames.length > 1 ? (
          <div className={classes.dropdownContainer}>
            <span className={classes.label}>Route</span>
            <Dropdown
              autoFocus={false}
              placeholder="Select route"
              value={driverInfo.routeId}
              options={currentDriverRouteNames}
              onChange={changeRouteData}
              isDisabled={currentDriverRouteNames.length === 1}
            />
          </div>
        ) : (
          <Details label="Route" value={driverInfo.routeName} minWidth/>
        )}
      </div>
      <div className={classes.innerContainer}>
        {currentDriverManifests.length > 1 ? (
          <div className={classes.dropdownContainer}>
            <span className={classes.label}>Manifest</span>
            <Dropdown
              autoFocus={false}
              placeholder="Select manifest"
              value={driverInfo.manifestNumber}
              options={currentDriverManifests}
              onChange={changeRouteData}
              isDisabled={currentDriverManifests.length === 1}
            />
          </div>
        ) : (
          <Details label="Manifest" value={driverInfo.manifestNumber} minWidth/>
        )}
        {currentDriverTrailers.length > 1 ? (
          <div className={classes.dropdownContainer}>
            <span className={classes.label}>Trailer</span>
            <Dropdown
              autoFocus={false}
              placeholder="Select trailer"
              value={driverInfo.trailerNumber}
              options={currentDriverTrailers}
              onChange={changeRouteData}
              isDisabled={currentDriverTrailers.length === 1}
            />
          </div>
        ) : (
          <Details
            label="Trailer"
            value={trailerNumberWithScacCode}
            minWidth
          />
        )}
      </div>
    </div>
  );
};
export default withStyles(styles)(EquipmentContainer);
